export const deliverables = [
  {
    id: 'ea',
    icon: 'ri-file-code-line',
    title: 'GoldWarden.ex5',
    text: 'The compiled expert advisor, ready to drop straight into MetaTrader 5. No source code needed, no compiler required.',
  },
  {
    id: 'preset',
    icon: 'ri-equalizer-line',
    title: 'Personalised Risk Preset',
    text: 'A .set file sized to your account balance, so lot sizes and risk are correct from the very first trade.',
  },
  {
    id: 'guide',
    icon: 'ri-book-open-line',
    title: 'Setup Guide',
    text: 'A step-by-step installation walkthrough with screenshots — plus live help in the chat if you get stuck.',
  },
  {
    id: 'updates',
    icon: 'ri-refresh-line',
    title: 'Free Lifetime Updates',
    text: 'Every future version and preset update is sent to you free of charge through the same support chat.',
  },
];

export const fitFor = [
  {
    id: 'hands-off',
    icon: 'ri-time-line',
    title: 'You want gold exposure without babysitting',
    text: 'The EA scans and trades the London and New York sessions on its own, so you do not need to sit in front of a chart all day.',
  },
  {
    id: 'patient',
    icon: 'ri-wallet-3-line',
    title: 'You can start small and let it compound',
    text: 'Around $500 is enough to run the presets correctly. The account is designed to grow over months, not to be doubled in a week.',
  },
  {
    id: 'risk-first',
    icon: 'ri-shield-check-line',
    title: 'You would rather survive than gamble',
    text: 'You value a hard stop on every trade and a fixed risk per position over chasing the single biggest month possible.',
  },
  {
    id: 'verify',
    icon: 'ri-eye-line',
    title: 'You want the real account, not a polished backtest',
    text: 'You like the idea of judging performance from a live account instead of a polished backtest screenshot.',
  },
];

export const notFitFor = [
  {
    id: 'get-rich',
    icon: 'ri-rocket-line',
    title: 'You expect guaranteed daily returns',
    text: 'No honest expert advisor promises double-digit gains every day. If that is the goal, this is not the tool for you.',
  },
  {
    id: 'micro-manage',
    icon: 'ri-emotion-unhappy-line',
    title: 'You want to intervene on every trade',
    text: 'GoldWarden works best left alone. Manually closing and re-opening trades usually hurts the outcome, not helps it.',
  },
  {
    id: 'no-drawdown',
    icon: 'ri-forbid-line',
    title: 'You cannot stomach a losing month',
    text: 'Gold drawdowns are real — a red month happens. If that would stop you sleeping, start on a demo and keep the size tiny.',
  },
  {
    id: 'signals',
    icon: 'ri-group-line',
    title: 'You are hunting for a quick-money signal group',
    text: 'This is a tool you run and understand, not a promise that removes all the risk. We would rather you skip it than mis-sell it.',
  },
];